<template>
  <CRow class="justify-content-center">
    <Modal :modal="modal"></Modal>

    <!-- Content -->
    <CCol col="12">
      <div class="d-flex align-items-center justify-content-end mb-3">
        <a
          href="javascript:void(0)"
          @click="$router.go(-1)"
        >
          <CIcon
            name="cil-arrow-left"
            class="mr-2"
          />Voltar
        </a>
      </div>

      <CForm @submit.prevent="send">
        <!-- Title -->
        <CCard>
          <CCardHeader>
            <div class="d-flex justify-content-between align-items-center">
              <h4 class="mb-0">
                {{ $route.params.id ? 'Editar Aplicação' : 'Cadastrar Aplicação' }}
              </h4>

              <div class="d-flex align-items-center">
                <div class="ml-2 d-flex align-items-center">
                  <label class="mb-0">
                    <b>Status</b>
                  </label>

                  <CSwitch
                    type="checkbox"
                    color="success"
                    variant="3d"
                    class="mx-2"
                    v-bind="labelIcon"
                    :checked.sync="form.status"
                  />
                </div>
              </div>
            </div>
          </CCardHeader>
        </CCard>

        <!-- Content -->
        <CCard>
          <CCardBody>
            <CTabs
              :active-tab="activeTabIndex"
              :vertical="vertical"
              :variant="variant"
              add-nav-wrapper-classes="website-tabs"
              add-tabs-wrapper-classes="website-tabs"
              class="ml-1"
              @update:activeTab="handleActiveTab"
            >
              <!-- BR -->
              <CTab>
                <!-- Tab title -->
                <template
                  slot="title"
                >
                  <div class="d-flex align-items-center">
                    <img
                      :src="require(`@/assets/img/flags/pt-br.svg`)"
                      alt="Bandeira Inglesa"
                      class="flag mr-2"
                    />
                    Português
                    <TabsStatus :exibition="form.status" />
                  </div>
                </template>

                <!-- Fields -->
                <div class="subtitle">
                  <h5>
                    <CIcon
                      name="cil-justify-center"
                    />
                    Informações
                  </h5>
                </div>

                <CRow>
                  <!-- Title -->
                  <CCol lg="4">
                    <CInput
                      id="first"
                      v-model="form.title"
                      label="Título*"
                      :disabled="processing"
                    />
                  </CCol>

                  <!-- Solutions -->
                  <CCol lg="4">
                    <div class="form-group">
                      <label for="">Solução*</label>

                      <Multiselect
                        :value="solutionsOptions.find(option => option.value == form.solution_id)"
                        :options="solutionsOptions"
                        label="label"
                        track-by="value"
                        placeholder="Solução"
                        :disabled="processing"
                        @select="(selected) => form.solution_id = selected.value"
                      />
                    </div>
                  </CCol>

                  <!-- Link YT -->
                  <CCol lg="4">
                    <CInput
                      v-model="form.video"
                      :disabled="processing"
                      type="url"
                      description="Ex: https://www.youtube.com/watch?v=mSdevWYk7Mk"
                    >
                      <template #label>
                        <label>Vídeo <small class="text-muted">(URL Youtube)</small></label>
                      </template>
                    </CInput>
                  </CCol>

                  <!-- Description -->
                  <CCol col="12">
                    <div class="form-group">
                      <label for="description">Descrição*</label>

                      <TextEditor
                        id="description"
                        v-model="form.description"
                        :disabled="processing"
                        type="simpletext"
                      />
                    </div>
                  </CCol>
                </CRow>

                <!-- Related Products -->
                <div class="subtitle">
                  <h5>
                    <CIcon
                      name="cil-justify-center"
                    />
                    Produtos Relacionados
                  </h5>
                </div>

                <CRow>
                  <CCol col="12">
                    <div class="form-group">
                      <label for="relatedProducts">Produtos</label>

                      <Multiselect
                        id="relatedProducts"
                        :value="productsOptions.filter((option) => form.products.includes(option.value))"
                        :options="productsOptions"
                        :searchable="true"
                        label="label"
                        track-by="value"
                        :multiple="true"
                        :limit="2"
                        :limit-text="count => `e ${count} mais`"
                        @select="(selected) => form.products.push(selected.value)"
                        @remove=" (removed) => form.products.splice(form.products.indexOf(removed.value),1)"
                      >
                        <span slot="noResult">Nenhum resultado encontrado</span>
                      </Multiselect>
                    </div>
                  </CCol>
                </CRow>

                <!-- Images -->
                <div class="subtitle">
                  <h5>
                    <CIcon
                      name="cil-justify-center"
                    />
                    Imagens
                  </h5>
                </div>

                <CRow>
                  <CCol col="12">
                    <div class="form-group">
                      <FileUploader
                        id="category-image"
                        :uploader-info="{ 'label': 'Imagem principal*' }"
                        :enable-multiple="false"
                        :enable-crop-on-uploader="true"
                        :enable-edit-on-api-table="false"
                        :max-files="1"
                        :accept-types="acceptTypes"
                        :extensions="extensions"
                        :medias="form.main_image"
                        :min-cropped-width="645"
                        :min-cropped-height="359"
                        uploader-type="banner"
                        :disabled="processing"
                      />
                    </div>
                  </CCol>

                  <CCol col="12">
                    <div class="form-group">
                      <FileUploader
                        id="category-images"
                        :enable-multiple="true"
                        :uploader-info="{ label: 'Galeria de imagens' }"
                        :enable-crop-on-uploader="false"
                        :enable-edit-on-api-table="true"
                        :max-files="25"
                        :accept-types="acceptTypes"
                        :extensions="extensions"
                        :medias="form.medias"
                        :min-cropped-width="645"
                        :min-cropped-height="359"
                        uploader-type="banner"
                        :disabled="processing"
                      />
                    </div>
                  </CCol>
                </CRow>

                <!-- SEO -->
                <div class="subtitle">
                  <h5>
                    <CIcon
                      name="cil-justify-center"
                    />
                    SEO
                  </h5>
                </div>

                <CRow>
                  <CCol
                    lg="12"
                  >
                    <FriendlyUrl
                      :value="form.slug"
                      :based-on="form.title"
                      :disabled="processing"
                      :entity="$route.params.id"
                      field="slug"
                      model="aplications"
                      @change="(value) => form.slug = value"
                    />
                  </CCol>

                  <CCol
                    col="12"
                  >
                    <Seo
                      :form="form.seo"
                      :page-title="form.title"
                      :page-description="form.description"
                      :is-edit="!!$route.params.id"
                    />
                  </CCol>
                </CRow>
              </CTab>

              <!-- EN -->
              <CTab>
                <!-- Tab title -->
                <template
                  slot="title"
                >
                  <div class="d-flex align-items-center">
                    <img
                      :src="require(`@/assets/img/flags/en.svg`)"
                      alt="Bandeira Inglesa"
                      class="flag mr-2"
                    />
                    Inglês
                    <TabsStatus :exibition="form.status_en && form.status" />
                  </div>
                </template>

                <!-- Title -->
                <div class="subtitle">
                  <h5>
                    <CIcon
                      name="cil-justify-center"
                    />
                    Informações
                  </h5>

                  <div class="d-flex align-items-center">
                    <div class="ml-2 d-flex align-items-center">
                      <label class="mb-0">
                        <b>Exibir</b>
                      </label>

                      <CSwitch
                        type="checkbox"
                        color="success"
                        variant="3d"
                        class="mx-2"
                        v-bind="labelIcon"
                        :checked.sync="form.status_en"
                      />
                    </div>
                  </div>
                </div>

                <!-- Fields -->
                <CRow>
                  <CCol lg="6">
                    <CInput
                      v-model="form.title_en"
                      :label="`Título*`"
                      :disabled="processing"
                    />
                  </CCol>

                  <CCol lg="6">
                    <CInput
                      v-model="form.video_en"
                      :disabled="processing"
                      type="url"
                      description="Ex: https://www.youtube.com/watch?v=mSdevWYk7Mk"
                    >
                      <template #label>
                        <label>Vídeo <small class="text-muted">(URL Youtube)</small></label>
                      </template>
                    </CInput>
                  </CCol>
                </CRow>

                <!-- Description -->
                <CRow>
                  <CCol lg="12">
                    <div class="form-group">
                      <label for="description">Descrição*</label>

                      <TextEditor
                        id="english-description"
                        v-model="form.description_en"
                        :disabled="processing"
                        type="simpletext"
                      />
                    </div>
                  </CCol>
                </CRow>

                <!-- Related products -->
                <CRow>
                  <CCol lg="12">
                    <div class="subtitle">
                      <h5>
                        <CIcon
                          name="cil-justify-center"
                        />
                        Produtos Relacionados
                      </h5>
                    </div>
                  </CCol>

                  <CCol lg="12">
                    <div class="form-group">
                      <label for="relatedProducts">Produtos</label>

                      <Multiselect
                        id="relatedProducts"
                        :value="productsOptions.filter((option) => form.products_en.includes(option.value))"
                        :options="productsOptions"
                        :searchable="true"
                        label="label"
                        track-by="value"
                        :multiple="true"
                        :limit="2"
                        :limit-text="count => `e ${count} mais`"
                        @select="(selected) => form.products_en.push(selected.value)"
                        @remove=" (removed) => form.products_en.splice(form.products_en.indexOf(removed.value),1)"
                      >
                        <span slot="noResult">Nenhum resultado encontrado</span>
                      </Multiselect>
                    </div>
                  </CCol>
                </CRow>

                <!-- SEO -->
                <CRow>
                  <CCol lg="12">
                    <div class="subtitle">
                      <h5>
                        <CIcon
                          name="cil-justify-center"
                        />
                        SEO
                      </h5>
                    </div>
                  </CCol>

                  <CCol
                    lg="12"
                  >
                    <FriendlyUrl
                      :value="form.slug_en"
                      :based-on="form.title_en"
                      :disabled="processing"
                      :entity="$route.params.id"
                      field="slug_en"
                      model="aplications"
                      @change="(value) => form.slug_en = value"
                    />
                  </CCol>
                </CRow>

                <Seo
                  :form="form.seo_en"
                  :page-title="form.title_en"
                  :page-description="form.description_en"
                  :is-edit="!!$route.params.id"
                />
              </CTab>

              <!-- ES -->
              <CTab>
                <!-- Tab title -->
                <template slot="title">
                  <div class="d-flex align-items-center">
                    <img
                      :src="require(`@/assets/img/flags/es.svg`)"
                      alt="Bandeira Espanhola"
                      class="flag mr-2"
                    />
                    Espanhol
                    <TabsStatus :exibition="form.status_es && form.status" />
                  </div>
                </template>

                <!-- Title -->
                <div class="subtitle">
                  <h5>
                    <CIcon
                      name="cil-justify-center"
                    />
                    Informações
                  </h5>

                  <div class="d-flex align-items-center">
                    <div class="ml-2 d-flex align-items-center">
                      <label class="mb-0">
                        <b>Exibir</b>
                      </label>

                      <CSwitch
                        type="checkbox"
                        color="success"
                        variant="3d"
                        class="mx-2"
                        v-bind="labelIcon"
                        :checked.sync="form.status_es"
                      />
                    </div>
                  </div>
                </div>

                <!-- Fields -->
                <CRow>
                  <CCol lg="6">
                    <CInput
                      v-model="form.title_es"
                      :label="`Título*`"
                      :disabled="processing"
                    />
                  </CCol>

                  <CCol lg="6">
                    <CInput
                      v-model="form.video_es"
                      :disabled="processing"
                      type="url"
                      description="Ex: https://www.youtube.com/watch?v=mSdevWYk7Mk"
                    >
                      <template #label>
                        <label>Vídeo <small class="text-muted">(URL Youtube)</small></label>
                      </template>
                    </CInput>
                  </CCol>
                </CRow>

                <!-- Description -->
                <CRow>
                  <CCol lg="12">
                    <div class="form-group">
                      <label for="spanish-description">Descrição*</label>

                      <TextEditor
                        id="spanish-description"
                        v-model="form.description_es"
                        :disabled="processing"
                        type="simpletext"
                      />
                    </div>
                  </CCol>
                </CRow>

                <!-- Related products -->
                <CRow>
                  <CCol lg="12">
                    <div class="subtitle">
                      <h5>
                        <CIcon
                          name="cil-justify-center"
                        />
                        Produtos Relacionados
                      </h5>
                    </div>
                  </CCol>

                  <CCol lg="12">
                    <div class="form-group">
                      <label for="relatedProducts">Produtos</label>

                      <Multiselect
                        id="relatedProducts"
                        :value="productsOptions.filter((option) => form.products_es.includes(option.value))"
                        :options="productsOptions"
                        :searchable="true"
                        label="label"
                        track-by="value"
                        :multiple="true"
                        :limit="2"
                        :limit-text="count => `e ${count} mais`"
                        @select="(selected) => form.products_es.push(selected.value)"
                        @remove=" (removed) => form.products_es.splice(form.products_es.indexOf(removed.value),1)"
                      >
                        <span slot="noResult">Nenhum resultado encontrado</span>
                      </Multiselect>
                    </div>
                  </CCol>
                </CRow>

                <!-- SEO -->
                <CRow>
                  <CCol lg="12">
                    <div class="subtitle">
                      <h5>
                        <CIcon
                          name="cil-justify-center"
                        />
                        SEO
                      </h5>
                    </div>
                  </CCol>

                  <CCol
                    lg="12"
                  >
                    <FriendlyUrl
                      :value="form.slug_es"
                      :based-on="form.title_es"
                      :disabled="processing"
                      :entity="$route.params.id"
                      field="slug_es"
                      model="aplications"
                      @change="(value) => form.slug_es = value"
                    />
                  </CCol>
                </CRow>

                <Seo
                  :form="form.seo_es"
                  :page-title="form.title_es"
                  :page-description="form.description_es"
                  :is-edit="!!$route.params.id"
                />
              </CTab>
            </CTabs>
          </CCardBody>
        </CCard>

        <!-- Logs -->
        <CRow v-if="$route.params.id">
          <CCol sm="12">
            <CardLog :log="log" />
          </CCol>
        </CRow>

        <!-- Actions -->
        <div class="form-actions">
          <a
            v-if="$route.params.id"
            href="javascript:void(0)"
            class="mr-3"
            @click="resetForm"
          >Limpar Alterações</a>
          <CInputCheckbox
            v-else
            label="Criar outro"
            class="mr-3"
            :disabled="processing"
            @update:checked="setRedirect"
          />
          <CButton
            color="success"
            type="submit"
            :disabled="processing"
          >
            {{ processing ? 'Salvando...' : 'Salvar' }}
          </CButton>
        </div>
      </CForm>
    </CCol>
  </CRow>
</template>

<script>
// Components
import FileUploader from '@/components/ui/Fileuploader'
import Modal from '@/components/ui/Modal'
import TextEditor from '@/components/ui/TextEditor'
import Seo from '@/components/ui/Seo'
import TabsStatus from '@/components/ui/TabsStatus'
import Multiselect from '@/components/ui/Multiselect'
import CardLog from '@/components/ui/CardLog'
import FriendlyUrl from '@/components/ui/FriendlyUrl'

import moment from 'moment'
import { cloneDeep } from 'lodash'

import Service from '@/services/applications.service'
import SolutionService from '@/services/solution.service'
import ProductService from '@/services/products.service'

export default {
  metaInfo: {
    title: 'Aplicação',
    titleTemplate: ' %s - Manager - Intelli'
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.$store.state.auth.permissions.includes('manage_applications')) {
        vm.$router.push('/404')
      }
    })
  },

  components: {
    FileUploader,
    Modal,
    TextEditor,
    Seo,
    TabsStatus,
    Multiselect,
    CardLog,
    FriendlyUrl
  },

  data() {
    return {
      vertical: false,
      variant: 'tabs',
      labelIcon: {
        labelOn: '\u2713',
        labelOff: '\u2715'
      },
      item: {
        solution_id: '',
        title: '',
        title_en: '',
        title_es: '',
        slug: '',
        slug_en: '',
        slug_es: '',
        video: '',
        video_en: '',
        video_es: '',
        description: '',
        description_en: '',
        description_es: '',
        views: '',
        status: true,
        status_en: false,
        status_es: false,
        medias: [],
        main_image: [],
        products: [],
        products_en: [],
        products_es: [],
        solution: '',
        seo: {
          seo_title: '',
          seo_description: ''
        },
        seo_en: {
          seo_title: '',
          seo_description: ''
        },
        seo_es: {
          seo_title: '',
          seo_description: ''
        }
      },
      form: {
        products: [],
        products_en: [],
        products_es: []
      },
      solutionsOptions: [],
      productsOptions: [],
      acceptTypes: 'image/png,image/jpeg',
      extensions: 'jpg,jpeg,png',
      uploaderInfo: {
        label: 'Imagem'
      },
      log: {
        created_by: '',
        created_at: '',
        updated_by: '',
        updated_at: ''
      },
      processing: false,
      new: true,
      query: {
        sorter: {}
      },
      modal: {
        show: false,
        title: '',
        message: '',
        color: ''
      },
      baseUrl: '',
      activeTabIndex: 0,
      redirect: true
    }
  },

  async created() {
    await this.getSolutionsOptions()
    await this.getProductsOptions()
    this.setItem()
  },

  methods: {
    async setItem() {
      if (this.$route.params.id) {
        const data = await Service.show(this.$route.params.id)

        if (data) {
          this.item = {
            id: this.$route.params.id,
            solution_id: data.solution_id,
            title: data.title,
            title_en: data.title_en,
            title_es: data.title_es,
            slug: data.slug,
            slug_en: data.slug_en,
            slug_es: data.slug_es,
            video: data.video,
            video_en: data.video_en,
            video_es: data.video_es,
            description: data.description,
            description_en: data.description_en,
            description_es: data.description_es,
            views: data.views,
            status: !!data.status,
            status_en: !!data.status_en,
            status_es: !!data.status_es,
            medias: data.medias,
            main_image: data.main_image,
            products: data.products.map(product => product.id),
            products_en: data.products_en.map(product => product.id),
            products_es: data.products_es.map(product => product.id),
            solution: {
              id: data.solution.id,
              title: data.solution.title
            },
            seo: {
              seo_title: data.seo.title,
              seo_description: data.seo.description
            },
            seo_en: {
              seo_title: data.seo_en.title,
              seo_description: data.seo_en.description
            },
            seo_es: {
              seo_title: data.seo_es.title,
              seo_description: data.seo_es.description
            }
          }

          this.log = {
            created_by: data.created ? data.created.name : 'Seed',
            created_at: moment(data.created_at).format('DD/MM/YYYY HH:mm'),
            updated_by: data.updated ? data.updated.name : null,
            updated_at: moment(data.updated_at).format('DD/MM/YYYY HH:mm')
          }
        }
      }

      this.form = cloneDeep(this.item)
    },

    async getSolutionsOptions() {
      const response = await SolutionService.index({ pagination: false, sorter: { column: 'title', asc: true } })

      this.solutionsOptions = response.data.map(item => {
        return {
          value: item.id,
          label: item.title
        }
      })
    },

    async getProductsOptions() {
      const response = await ProductService.index({ pagination: false, sorter: { column: 'title', asc: true } })

      this.productsOptions = response.data.map(item => {
        return {
          value: item.id,
          label: item.title
        }
      })
    },

    resetForm() {
      this.setItem()
    },

    setRedirect(event) {
      this.redirect = !event
    },

    handleActiveTab(index) {
      this.activeTabIndex = index
    },

    async send() {
      this.processing = true

      const validateYoutube = (link) => {
        const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/
        const match = link.match(regExp)

        return match
      }

      const openModal = (message) => {
        this.modal = {
          show: true,
          title: 'Erro',
          message: message,
          color: 'danger'
        }
      }

      if (this.form.video) {
        const link = validateYoutube(this.form.video)
        if (!link) {
          this.processing = false
          openModal('A URL do youtbue deve ser um link do youtube')
          return
        }
      }
      if (this.form.video_en) {
        const link = validateYoutube(this.form.video_en)
        if (!link) {
          this.processing = false
          openModal('A URL do youtbue em inglês deve ser um link do youtube')
          return
        }
      }
      if (this.form.video_es) {
        const link = validateYoutube(this.form.video_es)
        if (!link) {
          this.processing = false
          openModal('A URL do youtbue em espanhol deve ser um link do youtube')
          return
        }
      }

      let response
      let message

      const data = {
        id: this.$route.params.id,
        solution_id: this.form.solution_id,
        title: this.form.title,
        title_en: this.form.title_en,
        title_es: this.form.title_es,
        slug: this.form.slug,
        slug_en: this.form.slug_en,
        slug_es: this.form.slug_es,
        video: this.form.video,
        video_en: this.form.video_en,
        video_es: this.form.video_es,
        description: this.form.description,
        description_en: this.form.description_en,
        description_es: this.form.description_es,
        views: this.form.views,
        status: !!this.form.status,
        status_en: !!this.form.status_en,
        status_es: !!this.form.status_es,
        products: this.form.products,
        products_en: this.form.products_en,
        products_es: this.form.products_es,
        seo_title: this.form.seo.seo_title,
        seo_description: this.form.seo.seo_description,
        seo_title_en: this.form.seo_en.seo_title,
        seo_description_en: this.form.seo_en.seo_description,
        seo_title_es: this.form.seo_es.seo_title,
        seo_description_es: this.form.seo_es.seo_description,
        main_image_id: this.form.main_image && this.form.main_image.length ? this.form.main_image[0].id : null,
        medias: this.form.medias.map((media) => media.id)
      }

      if (this.$route.params.id) {
        response = await Service.update(this.$route.params.id, data)
        message = 'A aplicação foi atualizada com sucesso!'
      } else {
        response = await Service.store(data)
        message = 'A aplicação foi cadastrada com sucesso!'
      }

      this.processing = false

      if (response.status === 200) {
        this.modal = {
          show: true,
          title: 'Sucesso',
          message: message,
          color: 'success',
          redirect: this.redirect
        }

        if (this.redirect) {
          this.resetForm()
          setTimeout(() => {
            this.$router.push(
              this.$route.matched[this.$route.matched.length - 2].path
            )
          }, 3000)
        } else {
          this.resetForm()
          setTimeout(() => {
            this.processing = false
            document.getElementById('first').focus()
            this.modal.show = false
          }, 1000)
        }
      } else if (response.status === 400) {
        this.modal = {
          show: true,
          title: 'Erro',
          message: response.data.messages[0].message || response.data,
          color: 'danger'
        }
      } else {
        this.modal = {
          show: true,
          title: 'Erro',
          message: 'Ocorreu um erro interno, por favor tente novamente!',
          color: 'danger'
        }
      }
    }
  }
}
</script>
